<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();

const buttons = computed(() => {
  return contentAttributes.value.items || [];
});
</script>

<template>
  <BaseBubble class="p-3" data-bubble-name="button">
    <div v-if="content" class="mb-3 text-sm">{{ content }}</div>
    <div class="flex flex-wrap gap-2">
      <template v-for="(button, index) in buttons" :key="index">
        <a
          v-if="button.type === 'link' && button.uri"
          :href="button.uri"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center px-4 py-2 text-sm font-medium bg-n-solid-blue text-white rounded-md hover:bg-n-blue-10 transition-colors skip-context-menu"
        >
          {{ button.text || 'Click' }}
          <svg
            v-if="button.type === 'link'"
            class="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>
        <button
          v-else
          type="button"
          class="inline-flex items-center px-4 py-2 text-sm font-medium bg-n-slate-4 text-n-slate-12 rounded-md hover:bg-n-slate-5 transition-colors"
          :disabled="true"
        >
          {{ button.text || 'Button' }}
        </button>
      </template>
    </div>
  </BaseBubble>
</template>
